import cart from './cart'
export default `query cart($cartId: String!) {
  cart(cart_id: $cartId) {
     ${cart}
   }
 }`
